import { http } from "./config";
import authHeader from "./auth-header";

export default {
  listagem_falecidos: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    page,
    size
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      page: page,
      size: size
    };
    // Fazer a solicitação HTTP usando o Axios e passar os cabeçalhos configurados
    return http.get("/acompanhamento-dash/listagem-falecidos", {
      params: params,
      headers: authHeader(),
    });
  },

  listagem_falecidos_xls: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    page,
    size
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      page: page,
      size: size
    };
    // Fazer a solicitação HTTP usando o Axios e passar os cabeçalhos configurados
    return http.get("/planilha-dash/listagem-falecidos-xls", {
      params: params,
        responseType: 'blob',
      headers: authHeader(),
    });
  },
};
